import SubscriptionForm from "@components/SubscriptionForm"
import { useTranslation } from "react-i18next"
import { StripePrice } from "src/types"

interface Props {
  currency: string
  isSubmitting: boolean
  fullPrice: StripePrice | undefined
  priceId: string | undefined
  setIsSubmitting: (isSubmitting: boolean) => void
  timeLeft: string
  isWeekly: boolean
}

export default function LimitedTimeOfferBanner({
  currency,
  isSubmitting,
  fullPrice,
  priceId,
  setIsSubmitting,
  timeLeft,
  isWeekly,
}: Props) {
  const { t } = useTranslation()

  return (
    <div className="space-y-3 bg-blue-50">
      <div className="custom-container flex grow flex-row items-center justify-between py-4">
        <div className="flex flex-col">
          <p className="font-bold">
            {t("pages.onboarding.plans.discount_reserved")}
          </p>

          <p className="text-3xl font-bold">{timeLeft}</p>
        </div>

        <SubscriptionForm
          buttonClassName="!px-3 !py-2 !font-bold !text-base !shadow-none"
          buttonTitle={t("pages.onboarding.plans.startNow")}
          currency={currency}
          fullPrice={fullPrice}
          isSubmitting={isSubmitting}
          plan={isWeekly ? "weekly" : "yearly"}
          priceId={priceId}
          setIsSubmitting={setIsSubmitting}
        />
      </div>
    </div>
  )
}
